export const MOCK_PRODUCTS = [
  {
    id: 'kofta-skewers',
    name: 'Kofta Kabob Skewers',
    description: 'Hand-seasoned ground beef & lamb kofta, grilled on skewers. Served with your choice of sides.',
    base_price: 14,
    sizes: [{ name: 'Standard Plate', price: 14 }],
    images: ['/images/kofta-skewers.png'],
    available: true,
    sort_order: 0,
  },
  {
    id: 'rice-bowl',
    name: 'Yellow Rice Bowl',
    description: 'Fragrant turmeric-spiced rice topped with seasoned ground beef, fresh herbs, and warm spices.',
    base_price: 12,
    sizes: [{ name: 'Standard Bowl', price: 12 }],
    images: ['/images/rice-bowl.png'],
    available: true,
    sort_order: 1,
  },
];

export const MOCK_ORDERS = [
  {
    id: 'ORD-0001',
    customer_name: 'Alex Smith',
    delivery_date: '2025-11-15',
    status: 'paid',
    product_name: 'Kofta Kabob Skewers',
  },
];

export const MOCK_ADDONS = [
  { id: 'garlic_sauce', name: 'Garlic Sauce',   description: 'House-made creamy garlic sauce',       price: 1.50, image: '/images/garlic-sauce.png',  image_url: '/images/garlic-sauce.png',  available: true, sort_order: 0 },
  { id: 'ranch',        name: 'Homemade Ranch',  description: 'Fresh homemade buttermilk ranch',       price: 1.50, image: '/images/ranch.png',          image_url: '/images/ranch.png',          available: true, sort_order: 1 },
  { id: 'pita',         name: 'Pita Bread',      description: 'Warm, fresh-baked pita bread',          price: 1.00, image: '/images/pita.png',           image_url: '/images/pita.png',           available: true, sort_order: 2 },
  { id: 'faygo',        name: 'Faygo Pop',       description: 'Choose your favorite Faygo flavor',     price: 1.50, image: '/images/faygo.png',          image_url: '/images/faygo.png',          available: true, sort_order: 3 },
  { id: 'extra_skewer', name: 'Extra Skewer',    description: 'Add an extra kofta kabob skewer',       price: 5.00, image: '/images/extra-skewer.png',   image_url: '/images/extra-skewer.png',   available: true, sort_order: 4 },
];
